class @App.Pages.GetInvolved
  constructor: ->
    $(window).on 'load', (e) ->
      switch location.pathname
        when '/get_involved'
          $('a[href="#nominate-an-educator"]').tab('show')
        when '/nominate_an_educator'
          $('a[href="#nominate-an-educator"]').tab('show')
        when '/recommend_an_animator'
          $('a[href="#recommend-an-animator"]').tab('show')
        when '/start_a_teded_club'
          $('a[href="#start-a-teded-club"]').tab('show')

      switch location.hash
        when '#nominate-an-educator'
          $('a[href="#nominate-an-educator"]').tab('show')
        when '#recommend-an-animator'
          $('a[href="#recommend-an-animator"]').tab('show')
        when '#start-a-teded-club'
          $('a[href="#start-a-teded-club"]').tab('show')

    $('a[data-toggle="tab"]').on 'shown', (e) ->
      $target = $(e.target)
      $document = $(document)
      current_scroll = $document.scrollTop()
      window.location.hash = $target.attr('href')
      $document.scrollTop(current_scroll)

$(document).on 'turbo:load', ->
  new App.Pages.GetInvolved if $(document.body).hasClass 'pagesGetInvolvedView'
